import { Component, OnInit } from '@angular/core';
import { ParametreGeneral } from '../core/model/ParametreGeneral';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParametreGeneralService } from '../core/service/parametre-general.service';
import { AddParametreGeneralComponent } from './add-parametre-general/add-parametre-general.component';
import { EditParametreGeneralComponent } from './edit-parametre-general/edit-parametre-general.component';

@Component({
  selector: "app-parametre-general",
  templateUrl: "./parametre-general.component.html",
  styleUrls: ["./parametre-general.component.scss"]
})
export class ParametreGeneralComponent implements OnInit {
  parametreGeneral: ParametreGeneral[];

  constructor(
    private modalService: NgbModal,
    private _parametreGeneralService: ParametreGeneralService
  ) {}

  ngOnInit() {
    this.getParametreGeneral();
  }

  getParametreGeneral() {
    this._parametreGeneralService.getAllParametreGeneral().subscribe(
      data => {
        this.parametreGeneral = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  edit(parametreGeneral: ParametreGeneral): void {
    const modalRef = this.modalService.open(EditParametreGeneralComponent, {
      centered: true
    });
    modalRef.componentInstance.parametreGeneral = parametreGeneral;

    modalRef.result.then(
      data => {
        // on close
        this.getParametreGeneral();
      },
      reason => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddParametreGeneralComponent, {
      centered: true
    });

    modalRef.result.then(
      data => {
        // on close
        this.getParametreGeneral();
      },
      reason => {
        // on dismiss
      }
    );
  }
}
